import React from 'react'
import { PagesContextProvider as BaseProvider } from '@maui/elements'
import { useRootContext } from '../contexts/RootContext'

export const PagesContextProvider = props => {
  const { links = {} } = useRootContext()
  return <BaseProvider supportLink={links.contactUs} {...props} />
}
